import { FC } from 'react';
import SecureInput from 'src/v1-components/shared/SecureInput';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@spotnana/blocks/src/Typography';
import { ICvvRequirementInfo, IVGSFormInfo, useFeatureFlag } from 'obt-common';
import { useSetupCvvField } from './useSetupCvvField';
import { CvvDocLink } from './CvvDocLink';

interface IProps {
  cvvRequirement: ICvvRequirementInfo;
  vgsFormInfo: IVGSFormInfo;
  paymentSourceId: string;
  cvvJsonPath: string;
}

export const CVVInput: FC<IProps> = ({ cvvRequirement, vgsFormInfo, paymentSourceId, cvvJsonPath }) => {
  const { t: tt } = useTranslation('WEB');
  const isCvvDocLinkEnabled = useFeatureFlag('FE_PAYMENTS_CVV_DOC_LINK');

  const elementId = `payment-cvv-input-${paymentSourceId}`;

  const error = useSetupCvvField({
    cvvRequirement,
    vgsFormInfo,
    elementId,
    cvvJsonPath,
  });

  const showCvvDocLink = isCvvDocLinkEnabled && cvvRequirement.cvvDocLink;

  return (
    <>
      <SecureInput id={elementId} label={tt('CVV')} errorMessage={showCvvDocLink ? '' : error} />
      {showCvvDocLink && (
        <Typography variant="body2">
          <Trans
            t={tt}
            components={{
              CvvDocLink: <CvvDocLink cvvDocLink={cvvRequirement.cvvDocLink} />,
            }}
          >
            Click {'<CvvDocLink></CvvDocLink>'} to view CVV.
          </Trans>
        </Typography>
      )}
    </>
  );
};
